<template>
  <div class="page-content">
    <section>
      <div class="content-wrap">
        <label-form
v-if="!isLoading" :value="form" :loading="isSubmitting" @submit="handleSubmit"
          @validation-change="handleValidationChange" />

        <!-- Package Selector -->
        <package-selector v-if="!isLoading" ref="packageSelector" :initial-packages="initialPackages" />

        <!-- Actions -->
        <div class="form-actions-external">
          <el-button @click="handleCancel">
            ยกเลิก
          </el-button>
          <el-button :loading="isSubmitting" :disabled="!canSubmit" type="primary" @click="handleSubmit">
            บันทึก
          </el-button>
        </div>
      </div>
    </section>

    <!-- Loader -->
    <div v-loading.fullscreen.lock="isSubmitting || isLoading" element-loading-background="rgba(0, 0, 0, 0.4)">
    </div>

    <!-- Save Confirmation Alert -->
    <alert-dialog
:visible="confirm.open" :title="confirm.title" :message="confirm.message" confirm-text="บันทึก"
      @confirm="confirmSaveAction" @cancel="closeConfirm" />
  </div>
</template>

<script>
import { backendAdminClient } from "@/dependencies";
import LabelForm from '../components/LabelForm'
import PackageSelector from '../components/PackageSelector'
import AlertDialog from '../components/AlertDialog'
import { LabelRequest } from '../models/LabelRequest'
import { createLabelValidation, LABEL_CACHE_KEY } from '../utils/labelValidation'

export default {
  name: 'LabelEditPage',
  components: {
    LabelForm,
    PackageSelector,
    AlertDialog
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      isSubmitting: false,
      form: createLabelValidation(),
      isFormValid: false,
      initialPackages: [],
      confirm: {
        open: false,
        title: 'ยืนยันการบันทึก',
        message: 'ต้องการบันทึกข้อมูลใช่หรือไม่?'
      }
    }
  },
  computed: {
    canSubmit() {
      return this.isFormValid
    }
  },
  mounted() {
    this.$emit('sub-title', 'แก้ไข Label')

    if (!this.id) {
      this.$message.error('ไม่พบ ID ของ Label')
      this.$router.push({ name: 'LabelList' })
      return
    }

    // Try to get cached label from sessionStorage first
    if (this.loadFromCache()) {
      return
    }

    this.fetchLabel()
  },
  methods: {
    loadFromCache() {
      try {
        const cached = sessionStorage.getItem(LABEL_CACHE_KEY)
        if (!cached) return false

        const label = JSON.parse(cached)
        if (String(label.id) !== String(this.id)) {
          sessionStorage.removeItem(LABEL_CACHE_KEY)
          return false
        }

        this.form = createLabelValidation(label)
        this.isFormValid = this.form.nameTh.trim().length > 0
        this.initialPackages = label.packages || []
        sessionStorage.removeItem(LABEL_CACHE_KEY)

        return true
      } catch {
        sessionStorage.removeItem(LABEL_CACHE_KEY)
        return false
      }
    },
    async fetchLabel() {
      try {
        this.isLoading = true
        const label = await backendAdminClient.subscriptions.label.getById(this.id)

        this.form = createLabelValidation({
          nameTh: label.nameTh,
          nameEn: label.nameEn,
          nameZh: label.nameZh
        })

        this.initialPackages = label.packages || []

        this.$nextTick(() => {
          this.isFormValid = this.form.nameTh && this.form.nameTh.trim().length > 0
        })
      } catch (error) {
        this.$message.error((error && error.message) || 'Failed to load label')
        this.$router.push({ name: 'LabelList' })
      } finally {
        this.isLoading = false
      }
    },
    handleSubmit() {
      this.confirm.open = true
    },
    closeConfirm() {
      this.confirm.open = false
    },
    async confirmSaveAction() {
      this.closeConfirm()
      try {
        this.isSubmitting = true
        const selectedPackages = this.$refs.packageSelector.getSelectedPackages()
        const request = LabelRequest.fromForm(this.form, selectedPackages)

        await backendAdminClient.subscriptions.label.update(this.id, request.toJSON())

        this.$message.success('อัพเดท Label สำเร็จ')
        this.$router.push({ name: 'LabelList' })
      } catch (error) {
        this.$message.error((error && error.message) || 'Failed to update label')
      } finally {
        this.isSubmitting = false
      }
    },
    handleCancel() {
      this.$router.back()
    },
    handleValidationChange(isValid) {
      this.isFormValid = isValid
    }
  }
}
</script>
